import ThicknessDeviceImage from './ThicknessDeviceImage';

export default ThicknessDeviceImage;
